import styled from "styled-components";

export const CharactersSection = styled.section`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8rem 4.5rem;
  width: 100%;
  margin: 10rem auto;
`;
